var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 44,
    fill: "#ffe1d9",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 60 C 30 50 48 49 58 56 L 58 92 C 48 86 30 87 12 96 Z",
    fill: "#fffdfa",
    stroke: "#6f584a",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 60 C 90 50 72 49 62 56 L 62 92 C 72 86 90 87 108 96 Z",
    fill: "#fffdfa",
    stroke: "#6f584a",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 102 C 30 93 48 92 60 99",
    stroke: "#6f584a",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108 102 C 90 93 72 92 60 99",
    stroke: "#6f584a",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 96 L 12 102",
    stroke: "#6f584a",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108 96 L 108 102",
    stroke: "#6f584a",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64 C 34 58 46 57 54 61",
    stroke: "#dabcba",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98 64 C 86 58 74 57 66 61",
    stroke: "#dabcba",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 76 C 34 70 46 69 54 73",
    stroke: "#ecdcd5",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98 76 C 86 70 74 69 66 73",
    stroke: "#ecdcd5",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54 C 59 40 62 30 58 14",
    stroke: "#6f584a",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 42 C 48 39 42 30 43 20 C 52 23 58 31 59.5 42 Z",
    fill: "#d18e8b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30 C 70 26 76 17 74 9 C 65 12 61 20 60 30 Z",
    fill: "#9fb9c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.00b0c08cd6d3004b2822c841c8378f8b.svg";
export { ForwardRef as ReactComponent };